import { apiEndpoints } from "../../constants";
import { BaseService } from "./baseService";

class VisaRequestServices extends BaseService {
  async searchVisaRequestByPassport(passportId: string) {
    return await this.get(
      `${apiEndpoints.VISA_REQUEST.SEARCH_VISA_REQUEST}?passport_id=${passportId}`
    );
  }

  async createVisaRequest(payload: FormData) {
    const headers = {
      "Content-Type": "multipart/form-data"
    };

    return await this.post(
      apiEndpoints.VISA_REQUEST.CREATE_VISA_REQUEST,
      payload,
      headers
    );
  }

  async getVisaRequestById(visaRequestId: string) {
    return await this.get(
      `${apiEndpoints.VISA_REQUEST.GET_VISA_REQUEST}/${visaRequestId}`
    );
  }

  async getProfileByPurpose(purpose: string) {
    return await this.get(
      `${apiEndpoints.PROFILE.GET_PROFILE_BY_PURPOSE}?entry-purpose=${purpose}`
    );
  }

  async checkVisaRequestStatus(
    passportId: string,
    passportType: string,
    fullname?: string,
    dob?: string
  ) {
    return await this.get(
      `${apiEndpoints.VISA_REQUEST.CHECK_VISA_REQUEST_STATUS}?passport_id=${passportId}&passport_type=${passportType}` +
        (fullname ? `&fullname=${fullname}` : "") +
        (dob ? `&dob=${dob}` : "")
    );
  }

  async updateVisaRequest(visaRequestId: string, payload: FormData) {
    const headers = {
      "Content-Type": "multipart/form-data"
    };
    return await this.put(
      `${apiEndpoints.VISA_REQUEST.UPDATE_VISA_REQUEST}/${visaRequestId}`,
      payload,
      headers
    );
  }
}

const visaRequestServices = new VisaRequestServices();
export default visaRequestServices;
